"use strict";
exports.__esModule = true;
exports.chart_donut_threshold_second_Color = {
  "name": "--pf-chart-donut--threshold--second--Color",
  "value": "#d2d2d2",
  "var": "var(--pf-chart-donut--threshold--second--Color, #d2d2d2)"
};
exports["default"] = exports.chart_donut_threshold_second_Color;